import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../../components/header/Header';
import './LegalPages.scss';

class PrivacyPolicy extends Component {
  gotoHome = () => {
    this.props.history.push('/');
  };

  scrollTo = (section) => {
    this.props.history.push({
      pathname: '/',
      state: { section },
    });
  };

  render() {
    return (
      <section className="legal-page">
        <Header
          theme="light"
          scrollTo={this.scrollTo}
          logoAction={this.gotoHome}
        />
        <div className="legal-main">
          <div className="max-container">
            <h1>Privacy Policy</h1>
            <p className="effective-date">
              <strong>Effective Date:</strong> January 2024
            </p>

            <section>
              <h2>Introduction</h2>
              <p>
                Co-creation Hub (CcHUB) operates the SCI-Trade platform. This Privacy Policy explains
                how we collect, use, disclose, and safeguard your information when you use our
                SCI-Trade Opportunity Index platform.
              </p>
              <p>
                We are committed to protecting your personal data in accordance with applicable
                domestic, regional, and international privacy laws, including:
              </p>
              <ul>
                <li>
                  <strong>Rwanda — Law Nº 058/2021 on the Protection of Personal Data and Privacy:</strong> As
                  a platform operating within Rwanda, we comply with Rwanda's data protection framework,
                  including lawful processing, data minimisation, and the rights of data subjects under
                  this law.
                </li>
                <li>
                  <strong>Nigeria — Nigeria Data Protection Act (NDPA) 2023:</strong> As a platform
                  developed by a Nigeria-based organisation (CcHUB), we adhere to the NDPA 2023,
                  including requirements for lawful basis of processing, data subject rights, and
                  accountability obligations.
                </li>
                <li>
                  <strong>African Union — Malabo Convention (AU Convention on Cyber Security and
                  Personal Data Protection):</strong> We align our data governance practices with the
                  continental framework established by the Malabo Convention, supporting the AU's
                  vision for a trusted and secure digital Africa.
                </li>
                <li>
                  <strong>GDPR (General Data Protection Regulation — EU):</strong> We apply GDPR
                  principles as a global best practice standard for data privacy, including lawful
                  basis for processing, transparency, data minimisation, purpose limitation, and
                  respect for individual rights — regardless of whether a user is based in the EU.
                </li>
                <li>
                  <strong>PCI DSS (Payment Card Industry Data Security Standard):</strong> All payment
                  processing on the SCI-Trade platform is handled by Flutterwave, a PCI DSS Level 1
                  certified payment provider. We do not store, process, or transmit cardholder data
                  directly, ensuring your financial information is protected to the highest industry standard.
                </li>
              </ul>
            </section>

            <section>
              <h2>Information We Collect</h2>
              <h3>Personal Information</h3>
              <ul>
                <li>Name and contact information when you register or contact us</li>
                <li>Payment information when using premium features</li>
                <li>IP address and location data for trade opportunity recommendations</li>
              </ul>
              <h3>Usage Data</h3>
              <ul>
                <li>Pages visited and features used</li>
                <li>Search queries and filters applied</li>
                <li>Time spent on the platform</li>
                <li>Device and browser information</li>
              </ul>
            </section>

            <section>
              <h2>Legal Basis for Processing</h2>
              <p>
                In line with the NDPA 2023, Rwanda Law Nº 058/2021, and GDPR principles, we only
                process your personal data where we have a lawful basis to do so, including:
              </p>
              <ul>
                <li>Your consent (e.g. for marketing communications)</li>
                <li>Performance of a contract (e.g. to provide platform services you've signed up for)</li>
                <li>Compliance with a legal obligation</li>
                <li>Our legitimate interests, where these are not overridden by your rights</li>
              </ul>
            </section>

            <section>
              <h2>How We Use Your Information</h2>
              <ul>
                <li>Provide trade opportunity data and insights</li>
                <li>Process payments for premium features</li>
                <li>Improve platform functionality and user experience</li>
                <li>Send important updates about the platform</li>
                <li>Comply with legal obligations under applicable laws</li>
              </ul>
            </section>

            <section>
              <h2>Information Sharing</h2>
              <p>We do not sell your personal information. We may share data with:</p>
              <ul>
                <li>
                  <strong>Flutterwave</strong> — for payment processing. Flutterwave is PCI DSS
                  Level 1 certified and processes transactions in accordance with applicable financial
                  data protection standards.
                </li>
                <li>Analytics providers for platform improvement</li>
                <li>Legal authorities when required by law</li>
              </ul>
            </section>

            <section>
              <h2>Data Security</h2>
              <p>
                We implement appropriate technical and organisational security measures in line with
                the requirements of Rwanda Law Nº 058/2021, the NDPA 2023, and GDPR principles,
                including:
              </p>
              <ul>
                <li>Encrypted data transmission (TLS/HTTPS)</li>
                <li>Secure payment processing via a PCI DSS Level 1 certified provider</li>
                <li>Regular security assessments</li>
                <li>Access controls and authentication</li>
              </ul>
            </section>

            <section>
              <h2>Your Rights</h2>
              <p>
                In accordance with Rwanda Law Nº 058/2021, the Nigeria Data Protection Act 2023,
                and GDPR principles, you have the right to:
              </p>
              <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate or incomplete data</li>
                <li>Request deletion of your account and associated data</li>
                <li>Withdraw consent and opt out of marketing communications at any time</li>
                <li>Data portability — receive a copy of your data in a structured, machine-readable format</li>
                <li>Object to or restrict certain types of processing</li>
              </ul>
              <p>
                To exercise any of these rights, please contact us using the details below.
              </p>
            </section>

            <section>
              <h2>International Data Transfers</h2>
              <p>
                Where personal data is transferred outside the country in which it was collected, we
                take steps to ensure that adequate protections are in place, consistent with the
                requirements of applicable laws including Rwanda Law Nº 058/2021 and the NDPA 2023.
              </p>
            </section>

            <section>
              <h2>Contact Information</h2>
              <p>
                For privacy-related questions, requests to exercise your rights, or concerns about
                how we handle your data, please contact Co-creation Hub (CcHUB).
              </p>
            </section>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(PrivacyPolicy);
